import React from 'react';
import { useDispatch, useSelector  } from 'react-redux';
import './cancelFaw.scss';
import { updateCurrentView, showFawPage, resetSelection } from '../../actions/index';
import { RootState } from '../../reducers/index';

import { dialogflowEvent } from '../../config/config';
import { DialogflowQueryType } from '../../widget/models/enum';
import { postMessageToClient } from '../../widget/chatservice/communicationService';

type CancelProps = {
  quickReplyHandler: (event:any, queryType : DialogflowQueryType, eventText: string, showText: boolean) => void
}

const CancelFaw = ({quickReplyHandler}: CancelProps) => {

  const dispatch = useDispatch();
  const lastSelectedScreen = useSelector((state: RootState) => { return state.fawData.lastSelectedScreen});
  
  const getStepNumber = () => {
    switch(lastSelectedScreen) {
        case 'type':
            return 1;
        case 'price':
            return 2;
        case 'varietal':
            return 3;
        default:
    }
}

  const onCancel = (e: any) => {
    dispatch(showFawPage(false));
    dispatch(resetSelection());
    const linkName = `web:chatbot:find a wine:preference:step${getStepNumber()}:cancel`;
    postMessageToClient({
      data : {
          linkName : linkName.toLowerCase(),
          linkType: 'chatbot find a wine',
      },
      methodHandler : "chatbotTriggerAdobeAnalytics"
    })
    
    quickReplyHandler(e, DialogflowQueryType.Event, dialogflowEvent.Chatbot_Additional_Questions, false);
  }

  const onTakeMeBack = () => {
    dispatch(updateCurrentView(lastSelectedScreen));
  }
  
  return (
    <div className="cancel-faw">  
       <div className="warning-icon">
          <img className="star" src="/images/alert-icon.png"/>
       </div>
       <div className="warning-text">
          <div>If you cancel now, you’ll lose your current</div>
          <div>selection and I can’t show you Dan’s</div>
          <div className="cancel-text">superb wines.</div>
          <div>Are you sure you want to cancel?</div>
       </div>

       <div className="action-buttons">
            <input type="button" value="Yes, cancel" id="faw-cancel" className='form-button secondary' onClick={ (event) => onCancel(event) }/>
            <input type="button" value="No, take me back" id="faw-back" className='form-button secondary' onClick={ () => onTakeMeBack() }/>
       </div>
    </div>
  )
}
  
export default CancelFaw